import { render, staticRenderFns } from "./NewHires.vue?vue&type=template&id=64b26b20"
import script from "./NewHires.vue?vue&type=script&lang=js"
export * from "./NewHires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports